const $ = require('jquery');

/**
 * @function
 * @description initialize Afterpay On-Site Messaging widget related events
 */
exports.init = function () {
    window.addEventListener('Afterpay.modalRenderComplete', function () {
        $('afterpay-modal').focus();
    });
};
